import React from 'react';
import combinationImage from '../../../../../../images/combination-lock.png';
import { t } from '../../../../../modules/infra/i18n';

const LockNotice = () => (
  <div className="c-wrapper">
    <img src={combinationImage} alt={t('customers:form.lock_notice.lock_icon_alt')} className="u-align-middle" />
    <div className="layout__item u-9/10 u-align-middle u-mb0">
      {t('customers:form.lock_notice.squire_clients_notice')}{' '}
      {t('customers:form.lock_notice.commander_clients_notice')}
    </div>
  </div>
);

export default LockNotice;
